import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "project-page" }
const _hoisted_2 = {
  key: 0,
  class: "project-page__side-menu"
}

import RouterVerticalTab from '@/components/router-vertical-tabs/router-vertical-tab.vue';
import RouterVerticalTabs from '@/components/router-vertical-tabs/router-vertical-tabs.vue';
import {
  GetAttributeOptionsResponseItem,
  ProjectModel,
  WeeekDataModel,
  WeeekOptionsGetPrioritiesRequest,
  WeeekOptionsGetStatusesRequest,
  WeeekOptionsGetTagsRequest,
  WeeekOptionsGetTypesRequest,
} from '@/models';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import {
  ArrowDownTrayIcon,
  Cog6ToothIcon,
  QueueListIcon,
  TagIcon,
  UserIcon,
} from 'tir-style-system/icons/outline';
import { computed, inject, onBeforeMount, onMounted, ref, Ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import WeeekOptionsGetProjectOptionsRequest from '../project-settings-weeek-page/models/WeeekOptionsGetProjectOptionsRequest';
import { AdapterService } from './adapter';
import { WeeekTabsEnum } from '../project-settings-weeek-page/enums';
import { TagModel } from '@/components/task-forms/models';
import { GetTagsListDetailRequest } from '@/components/tasks-kanban/components/options-filter/components/filter-parameter/adapter/models';
import { debounce } from 'tir-pm-debounce';

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'project-page',
  props: {
  /**Доступ к weeek */
  isAccessWeeek: { type: Boolean },
},
  emits: ["checkRightsFormQueue", "uppdateProject", "updateAllowImportWeeek"],
  setup(__props, { emit }) {

const router = useRouter();
/**Адаптер */
const adapter = new AdapterService();

/**Параметры */

/**События */


/**Информация о проекте */
const project = inject('project') as Ref<ProjectModel>;

/**id проекта */
const projectId = router.currentRoute.value.params.projectId;

/**api key */
const apiKey = ref();
/**Данные weeek */
const dataWeeek = ref<WeeekDataModel>({
  StatusesWeeek: [],
  PrioritiesWeeek: [],
  TypesWeeek: [],
  TagsWeeek: [],
});
/**Изначальные данные weeek */
const originalDataWeeek = ref<WeeekDataModel>({
  StatusesWeeek: [],
  PrioritiesWeeek: [],
  TypesWeeek: [],
  TagsWeeek: [],
});
/**Теги проекта ПМ */
const tagsProjectPm = ref<TagModel[]>([]);
/**Состояние weeek */
const weeekState = ref<boolean>();

/**Изменения в массиве weeek*/
const changeDataWeeek = computed(
  () => JSON.stringify(originalDataWeeek.value) !== JSON.stringify(dataWeeek.value),
);
/**Привязан ли токен */
const isTokenLinked = computed(() => !!apiKey.value);
/**Владелец */
const isOwner = computed(() => CurrentUser.Roles.includes(UserRoleEnum.Owner));
/**Админ проекта */
const isProjectAdmin = computed(() => !!project.value.Admins?.some((a) => a.Id == CurrentUser.Id));
/**Классы элемента с контентом */
const contentClasses = computed(() => ({ form: router.currentRoute.value.name == 'project-tags' }));
/**Подзаголовок настройки weeek*/
const subtitleWeeekSettings = computed(() =>
  isTokenLinked.value ? 'Токен привязан' : 'Токен не привязан',
);

/**Отслеживание изменения привязки токена */
watch(
  isTokenLinked,
  async () => {
    if (isTokenLinked.value) {
      await getAttributesWeeek();
    }
  },
  { immediate: true },
);

/**Перед рендером */
onBeforeMount(async () => {
  if (!isOwner.value && !isProjectAdmin.value) {
    const route = String(router.currentRoute.value.name);
    if (route == 'project-tags') {
      router.push('/');
    }
  }
});

/**После рендера  */
onMounted(async () => {
  await getSettingsProject();
});

/**Обновление api key */
const updateApiKey = (_value: string) => {
  apiKey.value = _value;
};
/** Получение настроек проекта*/
const getSettingsProject = async () => {
  const response = await adapter.getProjectOptionsAsync(
    new WeeekOptionsGetProjectOptionsRequest({
      ProjectId: Number(projectId),
    }),
  );
  if (response.IsSuccess) {
    apiKey.value = response.Value.ApiKey;
    weeekState.value = response.Value.WeeekEnable;
  }
};
/**Обновление оригинального массива статусов weeek */
const updateOriginalDataWeeek = () => {
  originalDataWeeek.value = JSON.parse(JSON.stringify(dataWeeek.value));
};
/**Получение сопоставления cтатусов weeek */
const getStatusesWeeek = async () => {
  const response = await adapter.getStatusesWeeek(
    new WeeekOptionsGetStatusesRequest({
      ProjectId: Number(projectId),
    }),
  );
  if (response.IsSuccess) {
    dataWeeek.value.StatusesWeeek = response.Value.Attributes;
    originalDataWeeek.value.StatusesWeeek = JSON.parse(JSON.stringify(response.Value.Attributes));
  }
};
/**Получение сопоставления приоритетов weeek */
const getPrioritiesWeeek = async () => {
  const response = await adapter.getPrioritiesWeeek(
    new WeeekOptionsGetPrioritiesRequest({
      ProjectId: Number(projectId),
    }),
  );
  if (response.IsSuccess) {
    dataWeeek.value.PrioritiesWeeek = response.Value.Attributes;
    originalDataWeeek.value.PrioritiesWeeek = JSON.parse(JSON.stringify(response.Value.Attributes));
  }
};
/**Получение сопоставления типов weeek */
const getTypesWeeek = async () => {
  const response = await adapter.getTypesAsync(
    new WeeekOptionsGetTypesRequest({
      ProjectId: Number(projectId),
    }),
  );
  if (response.IsSuccess) {
    dataWeeek.value.TypesWeeek = response.Value.Attributes;
    originalDataWeeek.value.TypesWeeek = JSON.parse(JSON.stringify(response.Value.Attributes));
  }
};
/**Получение сопоставления тегов weeek */
const getTagsWeeek = async () => {
  const response = await adapter.getTagsAsync(
    new WeeekOptionsGetTagsRequest({
      ProjectId: Number(projectId),
    }),
  );
  if (response.IsSuccess) {
    dataWeeek.value.TagsWeeek = response.Value.Attributes;
    originalDataWeeek.value.TagsWeeek = JSON.parse(JSON.stringify(response.Value.Attributes));
  }
};
/**Получить теги проекта */
const getTagsProject = async (_searchText?: string) => {
  const responce = await adapter.getTagsProjectPm(
    new GetTagsListDetailRequest({
      Search: _searchText,
      ProjectId: Number(projectId),
    }),
  );
  if (responce.IsSuccess) {
    tagsProjectPm.value = responce.Value.Items.map(
      (tag) =>
        new TagModel({
          Id: tag.Id,
          Color: tag.Color,
          Description: tag.Description,
          Name: tag.TagName,
        }),
    );
  }
};
/**Обновить состояние weeek */
const updateAllowImportWeeek = (state: boolean) => {
  emit('updateAllowImportWeeek', state);
};
/**Обновить данные проекта */
const uppdateProject = async () => {
  emit('uppdateProject');
  await getSettingsProject();
};
const searchTags = debounce((searchText: string) => getTagsProject(searchText), 300);
/**Получить атрибуты weeek */
const getAttributesWeeek = async () => {
  await getStatusesWeeek();
  await getPrioritiesWeeek();
  await getTypesWeeek();
  await getTagsWeeek();
  await getTagsProject();
};
/**Обновить список атрибутов weeek*/
const updateAttributesWeeek = async () => {
  const nameRoute = router.currentRoute.value.name;
  switch (nameRoute) {
    case WeeekTabsEnum.Statuses:
      await getStatusesWeeek();
      break;
    case WeeekTabsEnum.Priorities:
      await getPrioritiesWeeek();
      break;
    case WeeekTabsEnum.Types:
      await getTypesWeeek();
      break;
    case WeeekTabsEnum.Tags:
      await getTagsWeeek();
      break;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isOwner.value || isProjectAdmin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(RouterVerticalTabs, null, {
            default: _withCtx(({ currentTab }) => [
              (isOwner.value || isProjectAdmin.value)
                ? (_openBlock(), _createBlock(RouterVerticalTab, {
                    key: 0,
                    route: { name: 'project-namespaces' },
                    label: "Обзор проекта",
                    "current-tab": currentTab
                  }, {
                    left: _withCtx(() => [
                      _createVNode(_unref(QueueListIcon))
                    ]),
                    _: 2
                  }, 1032, ["current-tab"]))
                : _createCommentVNode("", true),
              (isOwner.value || isProjectAdmin.value)
                ? (_openBlock(), _createBlock(RouterVerticalTab, {
                    key: 1,
                    route: { name: 'project-settings' },
                    label: "Основная информация",
                    "current-tab": currentTab
                  }, {
                    left: _withCtx(() => [
                      _createVNode(_unref(Cog6ToothIcon))
                    ]),
                    _: 2
                  }, 1032, ["current-tab"]))
                : _createCommentVNode("", true),
              (isOwner.value || isProjectAdmin.value)
                ? (_openBlock(), _createBlock(RouterVerticalTab, {
                    key: 2,
                    route: { name: 'project-admins' },
                    label: "Администраторы",
                    "current-tab": currentTab
                  }, {
                    left: _withCtx(() => [
                      _createVNode(_unref(UserIcon))
                    ]),
                    _: 2
                  }, 1032, ["current-tab"]))
                : _createCommentVNode("", true),
              (isOwner.value || isProjectAdmin.value)
                ? (_openBlock(), _createBlock(RouterVerticalTab, {
                    key: 3,
                    route: { name: 'project-tags' },
                    label: "Теги",
                    "current-tab": currentTab
                  }, {
                    left: _withCtx(() => [
                      _createVNode(_unref(TagIcon))
                    ]),
                    _: 2
                  }, 1032, ["current-tab"]))
                : _createCommentVNode("", true),
              (weeekState.value && (isOwner.value || isProjectAdmin.value))
                ? (_openBlock(), _createBlock(RouterVerticalTab, {
                    key: 4,
                    class: "project-page__router-import-weeek",
                    route: { name: 'import-weeek' },
                    label: "Настройка импорта Weeek",
                    paragraph: "Токен не привязан",
                    "current-tab": currentTab
                  }, {
                    left: _withCtx(() => [
                      _createVNode(_unref(ArrowDownTrayIcon))
                    ]),
                    paragraph: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["project-page__router-paragraph", { 'project-page__token-linked-success': isTokenLinked.value }])
                      }, _toDisplayString(subtitleWeeekSettings.value), 3)
                    ]),
                    _: 2
                  }, 1032, ["current-tab"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["project-page__content", contentClasses.value])
    }, [
      _createVNode(_component_RouterView, {
        projectId: _unref(projectId),
        apiKey: apiKey.value,
        isAccessWeeek: __props.isAccessWeeek,
        isTokenLinked: isTokenLinked.value,
        dataWeeek: dataWeeek.value,
        changeDataWeeek: changeDataWeeek.value,
        tagsProjectPm: tagsProjectPm.value,
        onSearchTags: _unref(searchTags),
        onCheckRightsFormQueue: _cache[0] || (_cache[0] = ($event: any) => (emit('checkRightsFormQueue', $event))),
        onUppdateProject: uppdateProject,
        onUpdateAllowImportWeeek: updateAllowImportWeeek,
        onUpdateApiKey: updateApiKey,
        onUpdateProjectSettings: getSettingsProject,
        onUpdateOriginalDataWeeek: updateOriginalDataWeeek,
        onUpdateList: updateAttributesWeeek
      }, null, 8, ["projectId", "apiKey", "isAccessWeeek", "isTokenLinked", "dataWeeek", "changeDataWeeek", "tagsProjectPm", "onSearchTags"])
    ], 2)
  ]))
}
}

})